<div *ngIf="!isMobileView">
<p-sidebar
  #appMenu
  [visible]="true"
  position="left"
  [style]="styleData"
  class="layout-sidebar"
  [modal]="false"
  [dismissableMask]="true"
  [showCloseIcon]="false"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"

>
  <ng-template pTemplate="header">
    
    <img class="bar-logo" src="images/logo/ops-logo.png" alt="logo" /><span class="logo-text option-title">OPS PROCESS</span>
    
  </ng-template>
  <div class="menu-search">
    <input type="text" pInputText placeholder="Search menu..." [(ngModel)]="searchText" (input)="filterMenu()"
      class="w-full" />
  </div>

  <nav>
    <ol class="layout-menu">
      <li
        app-menuitem=""
        class="ng-star-inserted"
        *ngFor="let d of filteredMenu; let j = index"
      >
        <button
          pbutton=""
          type="button"
          pstyleclass="@next"
          enterfromclass="hidden"
          enteractiveclass="slidedown"
          leavetoclass="hidden"
          leaveactiveclass="slideup"
          class="p-element px-link ng-star-inserted cursor-pointer"
          style="border: 0px solid; background: transparent"
          [routerLink]="d.path ? d.path : null"
          (click)="toggleMainActive(d)"
          [ngClass]="{ 'router-link-active': d.active }"
        >
          <div class="menu-icon">
            <i
              style="
                color: var(--primary-color);
                font-size: 14px;
                font-weight: bold;
              "
              [class]="getIconClass(d.icon)"
            ></i>
          </div>
          <span class="option-title">{{ d.title }}</span>
          <i
            class="menu-toggle-icon pi pi-angle-down"
            *ngIf="d.children.length > 0"
          ></i>

        </button>
        <div
          class="overflow-y-hidden transition-all transition-duration-400 transition-ease-d-out ng-star-inserted"
          *ngIf="d.active"
        >
          <ol>
            <li
              app-menuitem=""
              class="ng-star-inserted"
              *ngFor="let lst of d.children"
              (click)="toggleNavActive(lst, d)"
            >
              <a
                routerlinkactive="router-link-active"
                [routerLink]="lst.path"
                class="ng-star-inserted"
                [ngClass]="{ 'router-link-active': lst.active }"
              >
                <span class="option-title">{{ lst.title }}</span>
              </a>
            </li>
          </ol>
        </div>
      </li>
    </ol>
  </nav>
</p-sidebar>
</div>




<div *ngIf="isMobileView">
<p-sidebar
  #appMenu
  [visible]="true"
  position="left"
  [style]="sidebarStyle"
  class="layout-sidebar"
  [modal]="false"
  [dismissableMask]="true"
  [showCloseIcon]="false"
  (onHide)="onSidebarOutsideClick()"
>
  <ng-template pTemplate="header">
    <div style="display:flex; align-items:center; justify-content:space-between; width:100%;">
      <ng-container *ngIf="!sidebarCollapsed">
        <img class="bar-logo" src="images/logo/ops-logo.png" alt="logo" />
        <span class="logo-text option-title">OPS PROCESS</span>
      </ng-container>
      <button 
        [ngClass]="sidebarCollapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"
        (click)="toggleSidebar()"
        [ngStyle]="{'margin-left': sidebarCollapsed ? '-6px' : '0px','cursor': 'pointer'}"
        style="border:none; background:transparent; font-size:16px;color: #EF4444;"
      ></button>
    </div>
  </ng-template>
  <nav>
    <ol class="layout-menu">
      <li
        app-menuitem=""
        class="ng-star-inserted"
        *ngFor="let d of tableData; let j = index"
      >
        <button
          pbutton=""
          type="button"
          pstyleclass="@next"
          enterfromclass="hidden"
          enteractiveclass="slidedown"
          leavetoclass="hidden"
          leaveactiveclass="slideup"
          class="p-element px-link ng-star-inserted"
          style="border: 0px solid; background: transparent"
          [routerLink]="d.path ? d.path : null"
          (click)="!sidebarCollapsed && toggleMainActive(d)"
          [ngClass]="{ 'router-link-active': d.active }"
          [ngStyle]="{cursor: sidebarCollapsed ? 'default' : 'pointer'}"
        >
          <div class="menu-icon">
            <i
              style="
                color: var(--primary-color);
                font-size: 14px;
                font-weight: bold;
              "
              [class]="getIconClass(d.icon)"
            ></i>
          </div>
          <span class="option-title">{{ d.title }}</span>
          <i
            class="menu-toggle-icon pi pi-angle-down"
            *ngIf="d.children.length > 0"
          ></i>

        </button>
        <div
          class="overflow-y-hidden transition-all transition-duration-400 transition-ease-d-out ng-star-inserted"
          *ngIf="d.active"
        >
          <ol>
            <li
              app-menuitem=""
              class="ng-star-inserted"
              *ngFor="let lst of d.children"
              (click)="toggleNavActive(lst, d)"
            >
              <a
                routerlinkactive="router-link-active"
                [routerLink]="lst.path"
                class="ng-star-inserted"
                [ngClass]="{ 'router-link-active': lst.active }"
              >
                <span class="option-title">{{ lst.title }}</span>
              </a>
            </li>
          </ol>
        </div>
      </li>
    </ol>
  </nav>
</p-sidebar>
</div>
